module.exports = __webpack_public_path__ + "assets/img/b1c4d555cf22f35a8259f6ee052d2e17.svg";